import { TELEGRAM_URL } from '~/common/constants';

export const REQUIRED_FIELD = 'Поле не должно быть пустым';

export const validateRequiredField = <T = string>(toValidate: T): string | true => {
  if (!toValidate) {
    return REQUIRED_FIELD;
  }

  return true;
};

const SOCIAL_URL = /(https?:\/\/)?(www\.)?(telegram|t)\.me\/|vk\.(com|ru)\/|max\.ru\//;

export const validateTelegramUrl = (toValidate: string): string | true => {
  if (TELEGRAM_URL.test(toValidate) || SOCIAL_URL.test(toValidate)) {
    return true;
  }

  return 'Неверный формат ссылки на канал';
};
